import { TextProps, Text } from "@mantine/core"
import { useRouter } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { DetailsTabs } from "../../../-components/details-tabs"
import { ProductionTitleText } from "../../../-components/production-title"
import { Page } from "../../../../../-components/Page"
import { DateOnly } from "../../../../../@client/System"
import { useSuspenseQueryGet } from "../../../../../typed-client/hooks/use-suspense-query-get"
import { dateToTimeOnly } from "../../../../../utils/date-to-time-only"
import { getFormattedDate } from "../../../../../utils/get-formatted-date"
import { getFormattedTimePeriod } from "../../../../../utils/get-formatted-time"
import { useBreakpoints } from "../../../../../utils/use-breakpoints"
import { Route } from "../$id"
import { CastsTab } from "../-components/-tabs/CastsTab"
import { StartTab } from "../-components/-tabs/start-tab"
import { ActivityTypeText } from "../-components/activity-type-text"

const navOpts = { replace: true }
export function ActivityTabs() {
  const { t } = useTranslation("app_server")
  const navigate = Route.useNavigate()
  const { tab } = Route.useSearch()
  const activityId = parseInt(Route.useParams().id)
  const search = Route.useSearch()

  const { data: activityDetails } = useSuspenseQueryGet(
    "/api/Activity/GetActivity",
    {
      activityId,
    }
  )

  const router = useRouter()
  React.useEffect(() => {
    router.invalidate()
  }, [])
  return (
    <Page
      crumbOverride={() => (
        <ActitivityTitleText fz="xl" fw={"bold"} activityId={activityId} />
      )}
    >
      <DetailsTabs
        onChange={(tab) =>
          navigate({ ...navOpts, search: { ...search, tab: tab } })
        }
        value={tab}
        tabs={[
          {
            value: "start",
            label: t("Start"),
            content: <StartTab activity={activityDetails} />,
          },
          {
            value: "casts",
            label: t("Casts"),
            content: <CastsTab activityId={activityId} />,
          },
        ]}
      />
    </Page>
  )
}
function ActitivityTitleText({
  activityId,
  ...props
}: { activityId: number } & TextProps) {
  const { data: activity } = useSuspenseQueryGet("/api/Activity/GetActivity", {
    activityId,
  })
  const { xs } = useBreakpoints()
  return (
    <Text {...props}>
      <Text span inherit>
        {getFormattedDate(activity?.date as DateOnly, xs ? "L " : "ddd L")}
      </Text>{" "}
      <Text span inherit>
        {activity?.timePeriod.start && xs
          ? dateToTimeOnly(new Date(activity.timePeriod.start))
          : getFormattedTimePeriod(activity?.timePeriod)}
      </Text>{" "}
      <ActivityTypeText
        span
        inherit
        name={xs ? activity.activityType.shortName : activity.activityType.name}
        foreColor={activity.activityType.foreColor}
        backColor={activity.activityType.backColor}
        rehearseNumber={activity.rehearseNumber}
      />{" "}
      <ProductionTitleText inherit span productionTitle={activity?.title} />{" "}
      <Text span inherit>
        {xs ? activity.locationShort : activity.location}
      </Text>
    </Text>
  )
}
